import { AxiosRequestConfig, AxiosResponse } from "axios";
import { CohesiveAPIClient } from "../../client";

import { route } from "../../utils";
import { ExecuteToolboxRequest, ExecuteToolboxResponse } from "./types";

const ENDPOINTS = {
  EXECUTE: "/api/v1/org/:organization_id/toolbox-actions/:action_name",
};

export class ToolboxAPI {
  constructor(private client: CohesiveAPIClient) {}

  async execute<
    T = any,
    D = Record<string, any>,
    N = Record<string, any>,
    P = Record<string, any>,
  >(request: ExecuteToolboxRequest<D>, config: AxiosRequestConfig<D> = {}) {
    const organizationId = await this.client.getOrgID();

    const url = route(ENDPOINTS.EXECUTE, {
      organization_id: organizationId,
      action_name: request.action_name,
    });

    if (request.integration_connection_id) {
      config.params = {
        ...config.params,
        integration_connection_id: request.integration_connection_id,
      };
    }

    if (request.entity_format) {
      config.params = {
        ...config.params,
        entity_format: request.entity_format,
      };
    }

    const response = await this.client.axios.post<
      ExecuteToolboxResponse<T, N, P>,
      AxiosResponse<ExecuteToolboxResponse<T, N, P>>,
      D
    >(url, request.action_input, config);

    return response.data;
  }
}
